import { getAuthorized } from "@/lib/fetch";
import { User } from "./user";

async function pingUserSession(): Promise<boolean> {
  try {
    const response = await getAuthorized(
      `${import.meta.env.VITE_BACKEND_URL}/users/ping`,
      undefined,
      false,
    );
    return response.status === 204;
  } catch (error) {
    return false;
  }
}

type MeIdentityResponse = {
  id: number;
  email: string;
  name: string;
  is_authenticated: boolean;
};

type MeAccessResponse = {
  roles: string[];
  permissions: string[];
  scopes: string[];
};

type AppConfigResponse = {
  menus: string[];
  workbooks: User["workbooks"];
  views: User["views"];
  tables: User["tables"];
  section_transcription: User["section_transcription"];
  section_route_overrides: User["section_route_overrides"];
};

async function getUserData(): Promise<User | null> {
  try {
    const meResponse = await getAuthorized(
      `${import.meta.env.VITE_BACKEND_URL}/users/me`,
      undefined,
      false,
    );
    const accessResponse = await getAuthorized(
      `${import.meta.env.VITE_BACKEND_URL}/users/me/access`,
      undefined,
      false,
    );
    const configResponse = await getAuthorized(
      `${import.meta.env.VITE_BACKEND_URL}/app/config`,
      undefined,
      false,
    );

    if (!meResponse.ok || !accessResponse.ok || !configResponse.ok) {
      return null;
    }

    const me = (await meResponse.json()) as MeIdentityResponse;
    const access = (await accessResponse.json()) as MeAccessResponse;
    const appConfig = (await configResponse.json()) as AppConfigResponse;

    const groups = Array.isArray(access.roles) ? access.roles : [];
    const onlyGateGroup = groups.length === 1 && groups[0] === "gate-users";

    return {
      name: me.name || me.email || "",
      email: me.email || "",
      workbooks: appConfig.workbooks ?? {},
      views: appConfig.views ?? {},
      tables: appConfig.tables ?? {},
      section_transcription: appConfig.section_transcription ?? {},
      section_route_overrides: appConfig.section_route_overrides ?? {},
      groups,
      only_gate_group: onlyGateGroup,
      user_id: me.id,
    };
  } catch (error) {
    return null;
  }
}

export { getUserData, pingUserSession };
